import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import alignElement from './alignElement';

class RefHolder extends React.Component {
  render() {
    return this.props.children;
  }
}

export default function Align({ children, to, method, padding, onUpdate }) {
  const ref = React.useRef();
  const frame = React.useRef();

  React.useLayoutEffect(() => {
    function update() {
      if (ref.current) {
        if (onUpdate) {
          onUpdate();
        }
        const fromElem = ReactDOM.findDOMNode(ref.current);
        const toValue = typeof to === "function" ? to() : to;
        const toElem = ReactDOM.findDOMNode(React.isValidElement(toValue) ? toValue : (toValue && toValue.current));
        if (fromElem && toElem) {
          const styles = alignElement(fromElem, toElem.getBoundingClientRect(), method, padding);
          for (const name in styles) {
            fromElem.style[name] = styles[name];
          }
          fromElem.style.zIndex = (parseInt(window.getComputedStyle(toElem).zIndex, 10) || 0) + 100;
        }
      }
      //frame.current = requestAnimationFrame(update);
    }

    frame.current = requestAnimationFrame(update);
    return () => cancelAnimationFrame(frame.current);
  }, [to, method, padding, onUpdate]);

  return <RefHolder ref={ref}>{children}</RefHolder>;
}

Align.propTypes = {
  children: PropTypes.element.isRequired,
  to: PropTypes.any.isRequired,
  method: alignElement.methodType.isRequired,
  padding: alignElement.paddingType,
  onUpdate: PropTypes.func,
};
